import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'
import autoHeight from './permission/autoHeight'
import copyText from './common/copyText'

export default function directive(app){
  app.directive('hasRole', hasRole)
  app.directive('hasPermi', hasPermi)
  app.directive('autoHeight', autoHeight)
  app.directive('copyText', copyText)
}